var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-loader",staticStyle:{"z-index":"25"},attrs:{"id":"loader-form"}},[_c('div',{staticStyle:{"background":"#fff","padding":"5px","border-radius":"50%"}},[_c('div',{staticClass:"custom-loader3"})])])
}]

export { render, staticRenderFns }